<template>
  <div class="_search-wrapper">
    <div class="_search">
      <input class="el-input" :value="currentValue" :placeholder="placeholder" @input="handleInput" />
      <button class="button" @click="_search()">
        <img src="~images/search.png" width="18" height="18" />
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  ._search-wrapper {
    vertical-align: middle;
    display: inline-block;
  }
  ._search {
    display: flex;
    position: relative;
    vertical-align: top;
    white-space: nowrap;
    min-width: 200px;
    &:hover {
      .clearable {
        display: block;
      }
    }
    .el-input {
      flex: 1;
      padding: 0 15px;
      height: 32px;
      font-size: 13px;
      max-width: 180px;
      -webkit-appearance: none;
      outline:none;
      padding-right: 0;
      border: 1px solid $color-border;
      box-sizing: border-box;
      border-radius: 20px 0 0 20px;
      &::-webkit-input-placeholder {
        color: #ccc
      }
      &:-ms-input-placeholder {
        color: #ccc
      }
      &::placeholder {
        color: #ccc
      }
      &:hover {
        border-color: $color-border
      }
    }
    > .button {
      user-select: none;
      height: 32px;
      background: $color-theme;
      border: none;
      width: 36px;
      padding-left: 2px;
      border-radius: 0 20px 20px 0;
      cursor: pointer;
      outline: none;
      &:hover {
        opacity: .72
      }
    }
  }
</style>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '请输入内容'
      }
    },
    data () {
      return {
        currentValue: this.value
      }
    },

    watch: {
      value(val) {
        this.currentValue = val
      }
    },

    methods: {
      handleInput() {
        const value = event.target.value
        this.currentValue = value
        this.$emit('input', value)
      },
      _search() {
        this.$emit('search')
      }
    }
  }
</script>
